import { render, staticRenderFns } from "./ArrowsMoveIcon.vue?vue&type=template&id=3b5d7b8d&"
import script from "./ArrowsMoveIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowsMoveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports